/*
  COMPONENT: CategoryArtists
  PURPOSE: Displays a horizontal scroller of artist cards (images with summary).
*/
import React from 'react'
import styled, { css } from 'styled-components'
import breakpoint from 'styled-components-breakpoint'

// components
import SectionContentBox from './SectionContentBox'
import ArtistCard from './ArtistCard'

// styles
// NOTE: don't use any gutters in this section component, so images scroll from edges
const Section = styled.section`
  background: ${(props) => props.theme.backgroundLight};
  padding: 48px 0;

  ${breakpoint('tablet')`
    padding: 38px 0 63px;
  `}
`
const Heading = styled(SectionContentBox)`
  margin-bottom: 35px;
  text-align: center;

  h3 {
    text-transform: uppercase;
    color: ${(props) => props.theme.headingDark};
  }

  h2 {
    color: ${(props) => props.theme.headingDark};
  }

  ${breakpoint('tablet')`
    margin-bottom: 48px;
  `}
`
const CardContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: flex-start;
  overflow-x: auto;
  margin: 0 auto;
  width: 100%;
  -webkit-overflow-scrolling: touch;
  overflow: -moz-scrollbars-none;
  &::-webkit-scrollbar {
    width: 0 !important;
    height: 0 !important;
  }
`
const Spacer = styled.div`
  flex: 1 0 ${(props) => props.theme.mobileGutter};
  line-height: 0;

  ${breakpoint('tablet')`${css`
    flex-basis: ${(props) => props.theme.desktopGutter};
  `}`}
`

// lookup
const sectionTitle = (category) =>
  ({
    Bass: 'Our Bassists',
    Cello: 'Our Cellists',
    Viola: 'Our Violists',
    Violin: 'Our Violinists',
  }[category])

// view
const CategoryArtists = ({ artists, category }) => {
  if (artists.length === 0) return null

  return (
    <Section>
      <Heading>
        <h3>Meet the Artists</h3>

        <h2>{sectionTitle(category)}</h2>
      </Heading>

      <CardContainer>
        <Spacer>&nbsp;</Spacer>

        {artists.map((artist) => (
          <ArtistCard key={artist.slug} artist={artist} />
        ))}

        <Spacer>&nbsp;</Spacer>
      </CardContainer>
    </Section>
  )
}

export default CategoryArtists
